import { ko } from 'date-fns/locale/ko';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { registerLocale } from 'react-datepicker';
import { useSelector } from 'react-redux';
import { Link, useSearchParams } from 'react-router-dom';
import { deleteMAKAB020, postPAJAH010 } from '../../../services/Api';
import Pagination from '../../../shared/components/Pagination';
import SearchDateRange from '../../../shared/components/SearchDateRange';
import SideNav from '../../../shared/components/SideNav';
import { MESSAGE } from '../../../shared/constants/app';
import { decodeToken, formatDate } from '../../../utils';

registerLocale('ko', ko);

const PAJAH010 = () => {
    const token = useSelector(({ auth }) => auth.login.token);
    const decode = decodeToken(token);
    const [searchParams, setSearchParams] = useSearchParams();
    const [data, setData] = useState([]);
    const [pages, setPages] = useState({});
    const page = searchParams.get('page') || 1;

    const getListData = (startDate, endDate) => {
        const startDateFormat = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endDateFormat = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        postPAJAH010({ page, startDate: startDateFormat, endDate: endDateFormat })
            .then(({ data }) => {
                setData(data.data);
                setPages(data.info);
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page]);

    const handleDelete = (seq) => {
        if (window.confirm(MESSAGE.confirm.delete)) {
            deleteMAKAB020(seq, decode?.memberID)
                .then(() => {
                    window.alert(MESSAGE.notify.deleteSuccess);
                    getListData();
                })
                .catch((error) => console.log(error));
        }
    };

    // const renderSendDate = (sendDate) => {
    //     const today = moment().format('YYYY-MM-DD');
    //     return sendDate === today ? '오늘' : moment(sendDate).format('YYYY.MM.DD');
    // };

    const handleSearchDateRange = (startDate, endDate) => {
        getListData(startDate, endDate);
    };

    // const getDisplayValue = (auth, item) => {
    //     if (auth === 'ROLE_C') {
    //         return item?.type === 'SEND' ? item?.toNameKor : item?.fromNameKor;
    //     } else if (auth === 'ROLE_P') {
    //         return item?.type !== 'SEND' ? item?.toBizCompany : item?.fromBizCompany;
    //     }
    //     return '';
    // };

    return (
        <div id="content" className="sub-page">
            <div className="container">
                <div id="top-sub-page">
                    <SideNav />
                    <div className="resume">
                        <div className="resume__inner">
                            <h3 className="resume__tit">쪽지</h3>
                            <SearchDateRange
                                handleSearchDateRange={handleSearchDateRange}
                                setSearchParams={setSearchParams}
                            />
                            {/* <table className="msg__table">
                                <thead>
                                    <tr>
                                        <th>지원자명</th>
                                        <th>쪽지내용</th>
                                        <th>발송일시</th>
                                        <th>회신일시</th>
                                        <th>관리</th>
                                    </tr>
                                </thead>
                                <tbody className="msg__border-bottom">
                                    {data && data.length > 0 ? (
                                        data.map((item) => (
                                            <tr key={item.seq}>
                                                <td>
                                                    <span className="msg__name">
                                                        {getDisplayValue(decode?.authorities, item)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="msg__block">
                                                        <span
                                                            className={`msg__type ${
                                                                item?.type === 'SEND' ? '' : 'msg__type--blue'
                                                            }`}
                                                        >
                                                            [{item?.type === 'SEND' ? '보낸쪽지' : '받은쪽지'}]
                                                        </span>
                                                        <br />
                                                        <Link to={`/pajah020-${item.seq}`} className="msg__txt">
                                                            {item?.title}
                                                        </Link>
                                                    </div>
                                                </td>
                                                <td>
                                                    {renderSendDate(item?.sendDate)}
                                                    <br />
                                                    {moment(item?.sendTime).format('HH:mm:ss')}
                                                    <br />
                                                    <span className={`msg__${item?.readed === 'Y' ? 'read' : 'new'}`}>
                                                        {item?.readed === 'Y' ? '읽음' : 'NEW'}
                                                    </span>
                                                </td>
                                                <td>
                                                    {item?.replied === 'Y' ? formatDate(item?.replyDate) : ''}
                                                    <br />
                                                    {item?.replied === 'Y' ? moment(item?.replyDate).format('HH:mm:ss') : ''}
                                                </td>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="msg__delete"
                                                        onClick={() => handleDelete(item.seq)}
                                                    >
                                                        <i className="icon icon-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={4}>데이터없습니다</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table> */}
                            <table className="msg__table">
                                <thead>
                                    <tr>
                                        <th style={{ width: '20%%' }}>보낸사람</th>
                                        <th style={{ width: '50%' }}>내용</th>
                                        <th style={{ width: '20%' }}>일시</th>
                                        <th style={{ width: '10%' }}>관리</th>
                                    </tr>
                                </thead>
                                <tbody className="msg__border-bottom">
                                    {data && data.length > 0 ? (
                                        data.map((item) => (
                                            <tr key={item.seq}>
                                                <td
                                                    style={{
                                                        fontWeight: item.unreadCount > 0 ? 600 : '',
                                                    }}
                                                >
                                                    {item.partnerGbn === 'C'
                                                        ? item.partnerCompany
                                                        : item.partnerGbn === 'P'
                                                        ? item.partnerName
                                                        : ''}
                                                </td>
                                                <td>
                                                    <div className="list-content-mess-wrap">
                                                        <Link
                                                            to={`/pajah020-${item.seq}`}
                                                            className="list-content-mess"
                                                            style={{
                                                                fontWeight: item.unreadCount > 0 ? 600 : '',
                                                            }}
                                                        >
                                                            <span>{item.latestContent}</span>
                                                        </Link>
                                                        {item.unreadCount > 0 && (
                                                            <span className="count-mess">{item.unreadCount}</span>
                                                        )}
                                                    </div>
                                                </td>
                                                {/* <td>{formatDateTime(item.latestSendDate)}</td> */}
                                                <td
                                                    style={{
                                                        fontWeight: item.unreadCount > 0 ? 600 : '',
                                                    }}
                                                >
                                                    {formatDate(item?.latestSendDate)}
                                                    <br />
                                                    {moment(item?.latestSendDate).format('HH:mm:ss')}
                                                </td>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="msg__delete"
                                                        onClick={() => handleDelete(item.seq)}
                                                    >
                                                        <i className="icon icon-trash-2"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={4}>데이터없습니다</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <Pagination pages={pages} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PAJAH010;
